import { createSlice } from "@reduxjs/toolkit";
import LoginService from "../services/login";
import {
  addSaga,
  createAsyncSaga,
  createSagaReducer,
  sagaSlice,
} from "./sagaStore";

const initialState: any = {
  beLogin: {
    loading: false,
    error: null,
    data: {},
  },
  googleLogin: {
    loading: false,
    error: null,
    data: {},
  },
  firebaseLogin: {
    loading: false,
    error: null,
    data: {},
  },
};

const Slice: sagaSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    ...createSagaReducer("beLogin", "beLogin"),
    ...createSagaReducer("googleLogin", "googleLogin"),
    ...createSagaReducer("firebaseLogin", "firebaseLogin", {
      success: (state: any, action: any) => {
        state.firebaseLogin.data = action.payload;
      },
    }),
    // Reset all login state - call this when user initiates a new login attempt
    // This prevents stale error states from blocking new login attempts
    resetLoginState: (state: any) => {
      state.beLogin = { loading: false, error: null, data: {} };
      state.googleLogin = { loading: false, error: null, data: {} };
      state.firebaseLogin = { loading: false, error: null, data: {} };
    },
  },
});

const fetchLoginSaga = createAsyncSaga(
  "beLogin",
  Slice,
  LoginService.customToken,
  ["email", "password"],
);
const googleLoginSaga = createAsyncSaga(
  "googleLogin",
  Slice,
  LoginService.googleLogin,
);
const firebaseLoginSaga = createAsyncSaga(
  "firebaseLogin",
  Slice,
  LoginService.firebaseToken,
);

// Login sagas should not be debounced to prevent race conditions
addSaga(Slice.actions.beLogin.type, fetchLoginSaga, 0);
addSaga(Slice.actions.googleLogin.type, googleLoginSaga, 0);
addSaga(Slice.actions.firebaseLogin.type, firebaseLoginSaga, 0);

export const { beLogin, googleLogin, firebaseLogin, resetLoginState } = Slice.actions;
export default Slice.reducer;
